//APPROUTESSS

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAccountStore } from '@jwp/ott-common/src/stores/accountStore';

import ErrorPage from '@jwp/ott-ui-react/src/components/ErrorPage/ErrorPage';
import RootErrorPage from '@jwp/ott-ui-react/src/components/RootErrorPage/RootErrorPage';

import About from '@jwp/ott-ui-react/src/pages/About/About';
import Home from '@jwp/ott-ui-react/src/pages/Home/Home';
import Search from '@jwp/ott-ui-react/src/pages/Search/Search';
import User from '@jwp/ott-ui-react/src/pages/User/User';
import LegacySeries from '@jwp/ott-ui-react/src/pages/LegacySeries/LegacySeries';
import MediaScreenRouter from '@jwp/ott-ui-react/src/pages/ScreenRouting/MediaScreenRouter';
import PlaylistScreenRouter from '@jwp/ott-ui-react/src/pages/ScreenRouting/PlaylistScreenRouter';
import Layout from '@jwp/ott-ui-react/src/containers/Layout/Layout';

import TerminosyCondiciones from '@jwp/ott-ui-react/src/pages/TerminosAviso/TerminosyCondiciones';
import AvisoPrivacidad from '@jwp/ott-ui-react/src/pages/TerminosAviso/AvisoPrivacidad';
import Programacion from '@jwp/ott-ui-react/src/pages/Programacion/Programacion';
import Pago from '@jwp/ott-ui-react/src/pages/Pagos/Pago';
//Cambio para contraseña
//import { useLocation } from 'react-router-dom';

import {
  PATH_ABOUT,
  PATH_CONTENT_LIST,
  PATH_LEGACY_SERIES,
  PATH_MEDIA,
  PATH_PLAYLIST,
  PATH_SEARCH,
  PATH_USER,
  RELATIVE_PATH_USER_ACCOUNT,
  RELATIVE_PATH_USER_FAVORITES,
  RELATIVE_PATH_USER_PAYMENTS,
} from '@jwp/ott-common/src/paths';

import { APP_CONFIG_ITEM_TYPE } from '@jwp/ott-common/src/constants';

import AccountSection from '@jwp/ott-ui-react/src/pages/User/sections/AccountSection/AccountSection';
import FavoritesSection from '@jwp/ott-ui-react/src/pages/User/sections/FavoritesSection/FavoritesSection';
import PaymentsSection from '@jwp/ott-ui-react/src/pages/User/sections/PaymentsSection/PaymentsSection';

import RoutesContainer from '#src/containers/RoutesContainer/RoutesContainer';
import Landing from '../Landing/Landing';


function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAccountStore();
  const location = window.location;

  if (loading) return null;

  const isCreateAccount =
    location.pathname.includes('/payments') &&
    location.search.includes('u=create-account');
    //Para que genere el cambio de contraseña correctamente
    if (!user && !isCreateAccount) {
    return <Navigate to={`/login${location.search}`} replace />;
    }


  return children;
}

export default function AppRoutes() {
  const { t } = useTranslation('error');

  return (
    <Routes>
      
      {/* Rutas públicas */}

      {/* Landing-P*/}
      <Route path="/login" element={<Landing />} />

      <Route path="/terminos" element={<TerminosyCondiciones />} />
      <Route path="/avisos" element={<AvisoPrivacidad />} />
      {/*ESTA LINEA 84 DE ABAJO LA VOY A DESCOMENTAR PARA QUE LA PROGRAMACION  SEA PUBLICA/PRUEBA Y EN LA LINEA 100 LA VOY A COMENTAR PORQUE ES LA PRIVADA*/}
      <Route path="/programacion" element={<Programacion />} />
      <Route path="/pago" element={<Pago />} />


      {/* Rutas PROTEGIDAS */}
      {/* OTT */}
      <Route
        element={
          <ProtectedRoute>
            <RoutesContainer />
          </ProtectedRoute>
        }
      >
        <Route element={<Layout />} errorElement={<RootErrorPage />}>

          {/* HOME ORIGINAL */}
          <Route index element={<Home />} />

          {/*Programación PRIVADA comentada objeto prueba*/}
          {/*<Route path="/programacion" element={<Programacion />*/}

          <Route
            path={PATH_PLAYLIST}
            element={<PlaylistScreenRouter type={APP_CONFIG_ITEM_TYPE.playlist} />}
          />

          <Route
            path={PATH_CONTENT_LIST}
            element={<PlaylistScreenRouter type={APP_CONFIG_ITEM_TYPE.content_list} />}
          />

          <Route path={PATH_MEDIA} element={<MediaScreenRouter />} />
          <Route path={PATH_LEGACY_SERIES} element={<LegacySeries />} />
          <Route path={PATH_SEARCH} element={<Search />} />

          <Route path={PATH_USER} element={<User />}>
            <Route path={RELATIVE_PATH_USER_ACCOUNT} element={<AccountSection />} />
            <Route path={RELATIVE_PATH_USER_FAVORITES} element={<FavoritesSection />} />
            <Route path={RELATIVE_PATH_USER_PAYMENTS} element={<PaymentsSection />} />
            <Route path="*" element={<Navigate to={RELATIVE_PATH_USER_ACCOUNT} />} />
          </Route>

          <Route path={PATH_ABOUT} element={<About />} />

          {/* 404 */}
          <Route
            path="*"
            element={
              <ErrorPage
                title={t('notfound_error_heading', 'Not found')}
                message={t(
                  'notfound_error_description',
                  "This page doesn't exist."
                )}
              />
            }
          />

        </Route>
      </Route>

    </Routes>
  );
}